let swipers = {
    main: {
        slider: false,
        elem: $('.js-slider-main'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            simulateTouch: false,
            allowTouchMove: false,
            loop: false,
            effect: 'fade',
            pagination: {
                el: '.js-slider-main-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-slider-main-next',
                prevEl: '.js-slider-main-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            autoplay: {
                delay: 4500
            },
            breakpoints: {
                599: {
                    allowTouchMove: true,
                }
            },
            on: {
                init: function () {
                    swipers.main.active = true;
                }
            }
        }
    },
    products: globalSwipers.products,
    articles: {
        slider: false,
        elem: $('.js-slider-articles'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            simulateTouch: false,
            allowTouchMove: false,
            loop: false,
            slidesPerView: 2,
            spaceBetween: 50,
            pagination: {
                el: '.js-slider-articles-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-slider-articles-next',
                prevEl: '.js-slider-articles-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                1439: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                    allowTouchMove: false,
                },
                767: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    allowTouchMove: false,
                },
                599: {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                    allowTouchMove: true,
                }
            }
        }
    },
};

$(function() {
    checkSliders(swipers);

    calculateSpecialListHeight({
        selector: '.js-index-categories-box'
    });

    rEvent.on('Window.resized', function() {
        $('.js-nav-content-list').removeAttr('data-height');

        if (checkResolution('cxs;xs2') !== swipers.products.buildForPhone) {
            swipers.products.slider.destroy(true, true);
            swipers.products.buildForPhone = null;
            swipers.products.active = false;
        }

        checkSliders(swipers);

        calculateSpecialListHeight({
            selector: '.js-index-categories-box',
            clearValues: true
        });
    });

    $('.js-play-video').on('click', function() {
        const $iframe = $(this).next(),
            src = $iframe.data('src');

        $iframe.attr('src', src);

        $(this).remove();

        if (swipers.main.active) {
            swipers.main.slider.autoplay.stop();
        }
    });
});
